/* eslint-disable no-extend-native */
import React, {useState, useContext} from 'react';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, MenuItem, Backdrop, CircularProgress, DialogContentText, Alert, AlertTitle} from '@mui/material';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, LinearProgress} from '@mui/material';
import xlsx from 'json-as-xlsx';
import Header from './header';
import { API } from '../conf';
import { TokenContext } from '../App';
import CongeRow from './conge-row';
import FiltresConge from './conges_filtre';


export default function ManageConge(props) {
    const [load, setLoad] = useState(true)
    const [sending, setSend] = useState(false)
    const [data, setData] = useState([])
    const [show, setShow] = useState(false)
    const [user , setUser] = useState()
    const [users , setUsers] = useState([])
    const [selected, setSelect] = useState('')
    const [date_debut , setDebut] = useState('')
    const [date_fin , setFin] = useState('')
    const [nbre_jours, setNbre] = useState(0)
    const [msg, setMsg] = useState()
    const [token, setToken] = useContext(TokenContext)
    const [usr_total_jours, set_usr_total] = useState(0)

    const rm_token =()=>{
        setToken()
        return []
    }
    const get_siege = () =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/siege/all'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : [])
        .then(json => resolve(json))
    })}

    const get_pasteurs = async() =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/pasteur'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : [])
        .then(json => resolve(json))  
    })}

    Array.prototype.sum = function (key) {
        return this.reduce((a, b) => a + (b[key] || 0), 0);
    }

    const get_usr_conges = async(usr_id) => {
        setSend(true)
        fetch(API.concat(`/conges/utilisateurs/${usr_id}`),{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        .then(response => response.status === 200 ? response.json() : null)
        .then(result => {
            if (result !== null) {
                set_usr_total(result.sum("nbre_jours"))
            } else {
                set_usr_total(0)
            }
            setSend(false)
        })        
    }

    function get_sundays(date_debut, date_fin) { return new Promise((resolve, reject) => {
        var start = new Date(date_debut);
        var finish = new Date(date_fin);
        var dayMilliseconds = 1000 * 60 * 60 * 24;
        var weekendDays = 0;
    
        while (start <= finish) {
            var day = start.getDay()
            if (day === 6) {
                weekendDays++;
            }
            start = new Date(+start + dayMilliseconds);
        }  
        resolve(weekendDays)
    })}

    function handleAddSubmit() {
        if(user&& date_debut&& date_fin){
            setSend(true)
            setMsg()
            fetch(API.concat('/conge/register'), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    user: user,
                    date_debut: date_debut,
                    date_fin: date_fin,
                    nbre_jours: nbre_jours,
                    status: 'validé'
                })
            })
            .then(response=> {
                console.log(response.status);
                return response.status === 200 ? response.json() : response.status === 409 ? response.text() : response.status === 401 ? rm_token() : null
            })
            .then(result => {
                if(typeof result === 'string'){
                    setMsg({
                        severity:'error',
                        title:'Erreur',
                        text:'**'.concat(result)
                    })
                } else if (result === null) {
                    setMsg('**Une erreur est survenue, veuillez réessayer ultérieurement')
                } else {
                    reset_add_form(true);
                    setData(old => old.concat(result))
                }
                setSend(false)
            })
        } else setMsg('**Vous devez remplir tous les champs obligatoires')
    }

    function reset_add_form(keepShow) {
        setShow(keepShow);setUser();setDebut('');setFin(''); setSelect('')
    }

    function update_conge(old_conge, updated_conge) {
        let dt = data
        dt[(dt.indexOf(old_conge))] = updated_conge
        setData(dt)
    }

    function rm(to_delete) {
        setData(old => old.filter(row => row._id !== to_delete))
    }

    function handleExport() {
        const siege = data.filter(row => row.utilisateur.departement !== 'pasteur')
        const pasteurs = data.filter(row => row.utilisateur.departement === 'pasteur')

        let excel = [
            {
              sheet: "Employés Siège",
              columns: [
                { label: "Employé", value: (row) => row.utilisateur.nom_complet }, 
                { label: "Département", value: (row) => row.utilisateur.departement.charAt(0).toUpperCase() + row.utilisateur.departement.slice(1) }, 
                { label: "Date début", value: row => new Date(row.date_debut.slice(0, -5)).toLocaleDateString() }, 
                { label: "Date fin", value: row => new Date(row.date_fin.slice(0, -5)).toLocaleDateString() }, 
                { label: "Nombre jours", value: "nbre_jours" }, 
              ],
              content: siege,
            },
            {
              sheet: "Pasteurs",
              columns: [
                { label: "Employé", value: (row) => row.utilisateur.nom_complet }, 
                { label: "Date début", value: row => new Date(row.date_debut.slice(0, -5)).toLocaleDateString() }, 
                { label: "Date fin", value: row => new Date(row.date_fin.slice(0, -5)).toLocaleDateString() },
                { label: "Nombre jours", value: "nbre_jours" }, 
              ],
              content: pasteurs,
            },
        ]
          
        let settings = {
            fileName: `congés_employés_FEAM_${Date.now().toLocaleString()}`, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        }
          
          xlsx(excel, settings) // Will download the excel file
    }

    React.useEffect(()=>{}, []);

    return(
        <div style={{position:'absolute', right:0, left:0, top:0, bottom:0}}>
            <Header title='Gestion des congés'/>
            <div style={{ padding: '5% 50px 0px 50px'}}>
                <div style={{display: 'flex', justifyContent: 'flex-end', alignItems:'center', marginLeft: 70}}>
                    <Button variant='contained' style={{marginRight:20}} color='valide' onClick={async()=>{ 
                        setSend(true)
                        const siege = await get_siege() 
                        const pasteurs = await get_pasteurs() 
                        setUsers(siege.concat(pasteurs)); setSend(false); setShow(true)
                        setSelect('')
                        setMsg()
                        
                    }}>
                        <span style={{textTransform:'uppercase'}}>Enregistrer un congé</span>
                    </Button>
                    <Button variant='contained' color='purple' onClick={handleExport}>
                        <span style={{textTransform:'uppercase'}}>Exporter</span>
                    </Button>
                </div>
                <FiltresConge setLoad={setLoad} data={data} setData={setData}/>
            </div>
            <div style={{display: 'flex', justifyContent:'center'}}>
                <TableContainer sx={{padding: '20px', margin: '20px 80px'}}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead component={Paper} elevation={4}>
                        <TableRow>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Employé</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Département</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Date début</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Date fin</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Nombre jours</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Actions</span></TableCell>
                        </TableRow>
                        </TableHead>

                        {!load && <TableBody>
                        {data.map((row) => (
                            <CongeRow conge={row} update_data={[update_conge, rm]} key={row._id}/>
                        ))}
                        </TableBody>}
                    </Table>
                    {load && <LinearProgress color='coral' sx={{width: '100%'}}/>} 
                </TableContainer>
            </div>
            {/* add dialog form */}
            {<Dialog open={show} onClose={()=> reset_add_form(false)} sx={{borderRadius:5}} >
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>Enregistrer un congé</DialogTitle>
                <DialogContent>
                {msg && <Alert severity={msg.severity}>
                    <AlertTitle>{msg.title}</AlertTitle>
                    {msg.text}
                </Alert>}
                <div style={{display:'flex', alignItems:'center', flexDirection:'column'}}>
                <div>
                    <TextField
                    id="outlined-select-currency"
                    select
                    fullWidth
                    required
                    style={{marginTop: 16}}
                    label="Employé"
                    value={selected}
                    onChange={(e)=> {
                        get_usr_conges(e.target.value._id)
                        setUser({
                            _id: e.target.value._id, 
                            nom_complet: e.target.value.nom.charAt(0).toUpperCase() + e.target.value.nom.slice(1) + ' ' + e.target.value.prenom.charAt(0).toUpperCase() + e.target.value.prenom.slice(1),
                            departement: e.target.value.departement
                        })
                        setSelect(e.target.value) 
                    }}
                    >
                    {users.map((option) => (
                        <MenuItem key={option._id} value={option}>
                            <span style={{textTransform: 'capitalize'}}>{option.nom.concat(' '.concat(option.prenom))}</span> 
                        </MenuItem>
                    ))}
                    </TextField>
                    {user && user.nom_complet && <DialogContentText style={{margin:'5px 0px'}}><span style={{color: 'coral', fontSize:15}}>Cet employé dispose actuellement de {30 - usr_total_jours} jours de congé</span></DialogContentText>}
                    <Grid container spacing={{xs: 3, md: 5}}>
                        <Grid item>
                            <TextField
                            margin="normal"
                            required
                            InputLabelProps={{shrink: true}}
                            label="Date de début"
                            type='date'
                            inputProps={{min: new Date(`01-01-${new Date().getFullYear()}`).toISOString().split("T")[0], max: new Date(`04-30-${new Date().getFullYear()+1}`).toISOString().split("T")[0]}}
                            value={date_debut}
                            onChange={(event)=> {
                                setDebut(event.target.value)
                                if (date_fin) {
                                    get_sundays(event.target.value, date_fin)
                                    .then(async(sundays)=>{
                                        const nbre_days = Math.round((new Date(date_fin).getTime() - new Date(event.target.value).getTime()) / (1000 * 60 * 60 * 24)) + 1 - sundays
                                        setNbre(nbre_days>0 ? nbre_days : 0)
                                        if (nbre_days < 1) {
                                           setFin('')
                                        } else if (usr_total_jours + nbre_days > 30) {
                                            setMsg({
                                                severity:'warning',
                                                title:"Attention, nombre de jours trop élevé",
                                                text: `Si vous enregistrez ce congé, ${user.nom_complet} cumulera ${usr_total_jours + nbre_days} jours de congé dépassant ainsi la limite des 30 jours`
                                            })
                                        } else setMsg()
                                    })
                                }
                            }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                            margin="normal"
                            required
                            InputLabelProps={{shrink: true}}
                            disabled={date_debut.length === 0}
                            label="Date de fin"
                            type="date"
                            inputProps={{min: date_debut ? new Date(date_debut).toISOString().split("T")[0]: "", max: date_debut ? new Date(new Date(date_debut).getTime()+(1000 * 60 * 60 * 24 * 35)).toISOString().split("T")[0] : ""}}
                            min={date_debut ? new Date(date_debut).toISOString().split("T")[0]: ""}
                            value={date_fin}
                            onChange={(event)=> {
                                setFin(event.target.value)
                                get_sundays(date_debut, event.target.value)
                                .then(async(sundays)=>{
                                    const nbre_days = Math.round((new Date(event.target.value).getTime() - new Date(date_debut).getTime()) / (1000 * 60 * 60 * 24)) + 1 - sundays
                                    setNbre(nbre_days)
                                    if (usr_total_jours + nbre_days > 30) {
                                        setMsg({
                                            severity:'warning',
                                            title:"Attention, nombre de jours trop élevé",
                                            text: `Si vous enregistrez ce congé, ${user.nom_complet} cumulera ${usr_total_jours + nbre_days} jours de congé dépassant ainsi la limite des 30 jours`
                                        })
                                    } else setMsg()
                                })
                            }}
                            />
                        </Grid>
                    </Grid>
                    <TextField
                    margin="normal"
                    style={{minWidth:130}}
                    required
                    InputLabelProps={{shrink: true}}
                    disabled={date_debut.length === 0 || date_fin.length === 0}
                    label="Nombre de jours"
                    type="number"
                    inputProps={{min:1, max:30, onKeyDown: (event) => {
                        event.preventDefault();
                     }, }}
                    min={1}
                    value={nbre_jours}
                    onChange={(event)=> setNbre(Number(event.target.value))}
                    />
                </div>
                </div>
                </DialogContent>
                <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                    <Button variant='contained' color='grey' onClick={()=> reset_add_form(false)}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                    <Button variant='contained' color='valide' 
                    disabled={sending || !user || !user.nom_complet ||!date_debut||!date_fin}
                    onClick={() => handleAddSubmit()}>
                        <span style={{color:'#000', fontWeight:'bold'}}>Enregistrer</span>
                    </Button>
                </DialogActions>
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={sending}
                >
                    <CircularProgress color="valide" />
                </Backdrop>
            </Dialog>}
            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={sending && typeof to_delete !== 'string' && !show}
            >
                <CircularProgress color="valide" />
            </Backdrop>
        </div>
    )
}